export type CrossFieldValidation = {
	crossFieldName: string;
	validation?: string;
};
